import { Api } from 'models/services/api';
import { UpdateBusinessCategoryQuery } from 'models/services/graphql';

import { BusinessCategoryData, BusinessCategoryDataToSave } from '../index';

type DataToUpdate = {
  id: string;
  input: BusinessCategoryDataToSave;
};

const RequestQuery = `
  mutation UpdateBusinessCategory($id: ID!, $input: BusinessCategoryInput!) {
    ${UpdateBusinessCategoryQuery}
  }
`;

type ResponseData = {
  data: {
    updateBusinessCategory: BusinessCategoryData
  }
}

class UpdateGql {

  readonly api: Api<ResponseData>;
  readonly document?: BusinessCategoryData;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToUpdate): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const document = api.response.data.updateBusinessCategory;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, api, document });
  }

}

export { UpdateGql };